module.exports = __webpack_public_path__ + "static/media/andre-benz.a9d57c8e.jpg";